import React, { Component } from "react";
import { updateTotals } from "../lib/payment-utils";
import CheckboxField from "../lib/mdb/checkbox-field";

/**
 * Returns a formatted currency string for the given amount
 * @param amount
 * @returns {string}
 */
function formatAmountWithoutCurrency(amount) {
  return formatter.format(amount || 0);
}

// currency formatter
const formatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
});

/**
 * This is the main component to render shopping
 * cart payment item configured for shopping cart.
 * Currently it support Checkbox type of payment items.
 * expected properties:
 *  idx
 *  payment
 *  state
 *  config
 */
class ShoppingCartPaymentItems extends Component {
  handleCheckboxChange(paymentItem, index, e) {
    if (paymentItem.mandatory) {
      return;
    }
    this.props.state.setValues((data) => {
      let clone = JSON.parse(JSON.stringify(this.props.state.data));

      clone.payments[this.props.idx].bundle.paymentItems.forEach(
        (item, index) => {
          if (item.code === paymentItem.code && paymentItem.selected) {
            clone.payments[this.props.idx].bundle.paymentItems[
              index
            ].amountReadOnly = true;
            clone.payments[this.props.idx].bundle.paymentItems[
              index
            ].selected = false;
            return e;
          }
          if (item.code === paymentItem.code && !paymentItem.selected) {
            clone.payments[this.props.idx].bundle.paymentItems[
              index
            ].amountReadOnly = false;
            clone.payments[this.props.idx].bundle.paymentItems[
              index
            ].selected = true;
            return e;
          }
        }
      );

      updateTotals(clone);
      data.totalPaymentAmount = clone.totalPaymentAmount;
      return clone;
    });
  }

  handleAmountKeyPress = (evt) => {
    const key = evt.key;
    const strCheck = "1234567890.";
    // 110 is decimal key on the numpad and IE treat that
    // differently than the period inside the strCheck
    if (
      strCheck.indexOf(key) === -1 &&
      evt.keyCode !== 110 &&
      evt.charCode !== 46
    ) {
      evt.preventDefault();
    }
  };

  handleTotalAmountChange = (evt) => {
    let name = evt.target.name;
    let value = evt.target.value;
    this.props.state.setValues((data) => {
      let clone = JSON.parse(JSON.stringify(this.props.state.data));
      if (clone.payments[this.props.idx].bundle.paymentItems.length > 0) {
        clone.payments[this.props.idx].bundle.paymentItems.forEach(
          (item, index) => {
            if (item.code === name) {
              clone.payments[this.props.idx].bundle.paymentItems[
                index
              ].paymentAmount = value;
              clone.payments[this.props.idx].bundle.paymentItems[
                index
              ].selected = true;
              item.paymentAmount = value;
              item.selected = true;
            }
          }
        );
      } else {
        if (clone.payments[this.props.idx].bundle.paymentItems.code === name) {
          clone.payments[this.props.idx].bundle.paymentItems.paymentAmount =
            value;
          clone.payments[this.props.idx].bundle.paymentItems.selected = true;
        }
      }

      //let updatedData = clone.payments[this.props.idx];
      //clone.payments[this.props.idx].bundle.paymentItems = updatedData
      updateTotals(clone);
      data.totalPaymentAmount = clone.totalPaymentAmount;
      return clone;
    });
  };

  render() {
    const { config, payment, idx, state } = this.props,
      { messages, channelCode } = config;
    const checkboxPadding = {
      paddingTop: "6%",
      paddingLeft: "6%",
    };
    const shoppingCartItemJsx = [];
    const index = 0;
    let header = "Payment Details";
    // currently it support Checkbox payment item configured for shopping cart.
    // todo to support checkbox boolean, radiobutton and dropdown
    if (state.data.payments[idx].bundle.paymentItems.length > 0) {
      header = state.data.payments[idx].bundle.paymentItems[0].headerLabel;
      state.data.payments[idx].bundle.paymentItems.forEach(
        (paymentItem, index) => {
                    shoppingCartItemJsx.push(
                      <tr key={"tr0" + index} data-bundle-item-code="monthlyCharge">
                        <td key={"td0" + index} className="payment-type-col">
                          <div className="pt-0 pl-2 h-50">
                            <CheckboxField
                              key={"key" + paymentItem.code + { index }}
                              name={"name" + paymentItem.code + { index }}
                              className="form-check pl-0"
                              inputClass="form-check-input"
                              labelClass="form-check-label"
                              checked={paymentItem.selected}
                              onChange={(e) => {
                                this.handleCheckboxChange(paymentItem, index, e);
                              }}
                            />

                            <label
                              key={"label" + index}
                              htmlFor="bundlemonthlyChargeCb"
                              className="form-check-label m-0"
                            ></label>
                          </div>
                        </td>
                        <td key={"td1" + index} className="payment-type-col">
                          {paymentItem.label}
                        </td>
                        <td
                          key={"td2" + index}
                          className="payment-amount-col prevent-toggle"
                        >
                          <div
                            key={"tddiv1" + index}
                            className="input-group input-group-minimal md-form form-group form-row form-sm form-3 pl-0 m-0"
                          >
                            <div key={"tddiv2" + index} className="input-group-prepend">
                              <span
                                key={"tddspan1" + index}
                                className="input-group-text black-text"
                              >
                                $
                              </span>
                            </div>
                            <input
                              readOnly={paymentItem.amountReadOnly}
                              name={paymentItem.code}
                              key={paymentItem.code}
                              type="text"
                              className="form-control mt-0 scaled text-right"
                              placeholder="0.00"
                              aria-describedby="bundle.paymentItems[0].paymentAmount"
                              defaultValue={formatAmountWithoutCurrency(
                                paymentItem.paymentAmount
                              )}
                              maxLength="20"
                              autoComplete="off"
                              required=""
                              onChange={this.handleTotalAmountChange}
                              onKeyPress={this.handleAmountKeyPress}
                              data-fv-field="bundle.paymentItems[0].paymentAmount"
                            />
                          </div>
                        </td>
                      </tr>
                    );
                    }
      );
    } else {
      let paymentItem = state.data.payments[idx].bundle.paymentItems;
      if(paymentItem.headerLabel){
        header = paymentItem.headerLabel;
      }
      shoppingCartItemJsx.push(
        <tr key={"tr0" + index} data-bundle-item-code="monthlyCharge">
          <td key={"td0" + index} className="payment-type-col">
            <div className="pt-0 pl-2 h-50">
              <CheckboxField
                key={"key" + paymentItem.code + { index }}
                name={"name" + paymentItem.code + { index }}
                className="form-check pl-0"
                inputClass="form-check-input"
                labelClass="form-check-label"
                checked={paymentItem.selected}
                onChange={(e) => {
                  this.handleCheckboxChange(paymentItem, index, e);
                }}
              />

              <label
                key={"label" + index}
                htmlFor="bundlemonthlyChargeCb"
                className="form-check-label m-0"
              ></label>
            </div>
          </td>
          <td key={"td1" + index} className="payment-type-col">
            {paymentItem.label}
          </td>
          <td key={"td2" + index} className="payment-amount-col prevent-toggle">
            <div
              key={"tddiv1" + index}
              className="input-group input-group-minimal md-form form-group form-row form-sm form-3 pl-0 m-0"
            >
              <div key={"tddiv2" + index} className="input-group-prepend">
                <span
                  key={"tddspan1" + index}
                  className="input-group-text black-text"
                >
                  $
                </span>
              </div>
              <input
                readOnly={paymentItem.amountReadOnly}
                name={paymentItem.code}
                key={paymentItem.code}
                type="text"
                className="form-control mt-0 scaled text-right"
                placeholder="0.00"
                aria-describedby="bundle.paymentItems[0].paymentAmount"
                defaultValue={formatAmountWithoutCurrency(
                  paymentItem.paymentAmount
                )}
                maxLength="20"
                autoComplete="off"
                required=""
                onChange={this.handleTotalAmountChange}
                onKeyPress={this.handleAmountKeyPress}
                data-fv-field="bundle.paymentItems[0].paymentAmount"
              />
            </div>
          </td>
        </tr>
      );
    }

    return (
      <div className="col-md-6">
        <div className="payment-bundle-container">
          <table className="table table-payment-bundle table-normalize-height table-sm-custom table-bordered-simple table-vertical-middle">
            <tbody>
              <tr className="subsection-title">
                <td colSpan="3">{header}</td>
              </tr>

              {shoppingCartItemJsx}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default ShoppingCartPaymentItems;
